<template>
  <div class="kiw-index">
    <app-view-layout
      header="KIW"
      fluid
      no-padding
    >
      <template #toolbarMenu>
        <KIWToolbarMenu />
      </template>

      <template #content>
        <v-card>
          <div class="py-0 px-8">
            <v-tabs v-model="tab">
              <v-tab
                v-for="value in options"
                :key="value.label"
                :href="`#${value.label}`"
                @click="filterKIW({ status: value.label })"
              >
                {{ value.tab }}
              </v-tab>
            </v-tabs>
          </div>
        </v-card>
        <div class="pt-8 pb-4 px-8">
          <v-tabs-items v-model="tab">
            <v-tab-item
              v-for="value in options"
              :key="value.label"
              :value="value.label"
              flat
            >
              <v-card
                class="py-6 px-8"
                flat
                tile
              >
                <KIWTable
                  v-if="tab === value.label"
                  :selected-items="selectedItems"
                  :header="value.title"
                  :kiw-list="kiwList"
                  :status="value.label"
                  @selectItem="toggleKIWSelection"
                  @clearList="selectedItems = []"
                />
              </v-card>
            </v-tab-item>
          </v-tabs-items>

          <AppPagination
            v-if="kiwList.length"
            @change="changePage"
          />
        </div>
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import AppPagination from '@/components/UI/AppPagination.vue';
import KIWToolbarMenu from '@/components/KIW/KIWToolbarMenu.vue';
import KIWTable from '@/components/KIW/KIWTable.vue';

export default {
  components: {
    AppViewLayout,
    KIWToolbarMenu,
    AppPagination,
    KIWTable,
  },

  props: {
    startTab: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      tab: '',
      selectedItems: [],
      options: [
        { label: 'pending', title: 'Lista nowych wniosków', tab: 'Lista wniosków KIW' },
        { label: 'accepted', title: 'Lista KIW', tab: 'Zaakceptowane wnioski KIW' },
        { label: 'rejected', title: 'Lista odrzuconych wniosków', tab: 'Odrzucone wnioski KIW' },
      ],
    };
  },

  computed: {
    ...mapState('kiw', [
      'kiwList',
    ]),
  },

  created() {
    if (this.startTab) {
      this.tab = this.startTab;
      this.filterKIW({ status: this.startTab });
    } else {
      this.filterKIW({ status: 'pending' });
    }
  },

  beforeDestroy() {
    this.resetKIW();
  },

  methods: {
    ...mapActions('kiw', [
      'fetchKIW',
      'resetKIW',
    ]),

    ...mapActions('filters', [
      'setFilters',
    ]),

    changePage() {
      this.selectedItems = [];
      this.fetchKIW();
    },

    filterKIW(filter) {
      this.selectedItems = [];
      this.setFilters(filter)
        .then(() => {
          this.fetchKIW();
        });
    },

    toggleKIWSelection(id) {
      if (this.selectedItems.includes(id)) {
        this.selectedItems = this.selectedItems.filter((kiwId) => kiwId !== id);
      } else {
        this.selectedItems.push(id);
      }
    },
  },
};
</script>
